import React from 'react';
import { DateUtils } from '../../../utils/dateUtils';

interface Photo {
    id: string;
    image: string;
    size?: string;
    created_at?: string;
}

interface ImageInfoModalProps {
    photo: Photo;
    onClose: () => void;
    selectedFolder?: any
}

const ImageInfoModal: React.FC<ImageInfoModalProps> = ({ photo, onClose, selectedFolder }) => {
    const getName = (url: any) => {
        const fileName = new URL(url)?.pathname?.split("/")?.pop();
        return fileName
    }
    return (
        <div className="lg-modal-overlay" onClick={onClose}>
            <div className="lg-modal" onClick={e => e.stopPropagation()}>
                <button className="lg-modal__close" onClick={onClose}>
                    <img src='/assets/images/dismiss.svg' alt='close' />
                </button>
                <h3 className="lg-modal__title">Image Information</h3>
                <div className="lg-modal__row"><span className="lg-modal__label">Filename</span><span className="lg-modal__value">{getName(photo?.image)}</span></div>
                <div className="lg-modal__row"><span className="lg-modal__label">Folder</span><span className="lg-modal__value">{selectedFolder?.name}</span></div>
                <div className="lg-modal__row"><span className="lg-modal__label">Size</span><span className="lg-modal__value">{photo?.size || '987KB'}</span></div>
                <div className="lg-modal__row"><span className="lg-modal__label">Date</span><span className="lg-modal__value">{`${DateUtils.formatDateTime(photo?.created_at, 'YYYY-MM-DD HH:mm')}`}</span></div>
            </div>
        </div>
    )
};

export default ImageInfoModal